import React from 'react'
import { l } from '@manychat/manyui'

const FBInsufficientRightsToReloadAccountNotification = () => {
  return <span>{l.translate('You have insufficient rights to reload the account')}</span>
}

export default FBInsufficientRightsToReloadAccountNotification
